import { IProductGenderSize } from '../../interfaces'

export const addGenderSize = (genderSize: IProductGenderSize) => genderSize

export const clearGenderSize = () => null
